export const locale = {
    lang: 'pt',
    data: {
      'EDITOR': {
        'ACERCADE': 'Opcionalmente, antes de criar a pesquisa, você pode editar algumas características dela, as alterações feitas podem ser visualizadas dentro da pesquisa uma vez acessada',
        'CONCAMBIOS': 'Foram detectadas alterações na configuração da pesquisa, primeiro você deve gerar a pesquisa para que as alterações feitas sejam aplicadas, depois você pode concluir a etapa',
        'CARGANDO': 'Carregando informação',
        'GUARDANDO': 'Salvando alterações',
        'CONFIGADICIONAL': {
          'TITULO': 'Configuração adicional',
          'SUBTITULO': 'Essas configurações se aplicam à pesquisa para todos os idiomas',
          'DISPONIBLES': 'Controles disponíveis',
          'SAVEOK': 'A configuração foi atualizada com sucesso',
          'CONTROLES': {
            'PIN': 'Ativar proteção de pesquisa com o PIN do usuário',
            'RANDOM': 'Habilite a pergunta de validação aleatória',
            'LIDERES': 'Mostrar nomes de líderes (CEO / chefe) nas perspectivas das declarações'
          }
        },
        'ELEMENTOS': {
          'GUIA': 'Elementos deste bloco',
          'COLORES': {
            'ORIGINAL': 'Elemento não modificado',
            'MODIFICADO': 'Elemento modificado'
          },
          'TOOLTIPS': {
            'ORIGINAL': 'Nenhum elemento foi modificado',
            'MODIFICADO': 'Um ou mais elementos foram modificados',
            'COMPLETO': 'Todos os elementos foram modificados'
          },
          'ETIQUETAS': {
            'IMAGEN': {
              'NOHAY': 'Não tem foto',
              'ACTUAL': 'Imagem atual'
            },
            'TEXTO': {
              'INGRESAR': 'Digite seu texto'
            }
          },
          'BOTONES': {
            'ENTRAR': 'Editar características da pesquisa',
            'REGRESAR': 'Volte',
            'CONTINUAR': 'Continuar',
            'CANCELAR': 'Cancelar',
            'GUARDAR': 'Salvar alterações',
            'IMAGEN': 'Mudar a imagem',
            'EDITOR': 'Editar mensagem',
            'ELEMENTOS': 'Ajuda',
            'ACTIVAR': 'mostrar',
            'DESACTIVAR': 'Esconder',
            'ACEPTAR': 'Aceitar',
          }
        },
        'PANTALLAS': {
          'LOGIN': {
            'TITULO': 'Conecte-se',
            'PASOS': {
              'LOGO': {
                'TITULO': 'Logotipo da corretora',
                'ELEMENTOS': {
                  'logo': 'Você pode fazer upload de uma imagem para alterar o logotipo do corretor'
                }
              },
              'INSTRUCCIONES': {
                'TITULO': 'Instruções anteriores',
                'ELEMENTOS': {
                  'text': 'Você pode escrever as instruções para mostrar antes de entrar na pesquisa'
                }
              },
              'LOGINFORM': {
                'TITULO': 'Forma de login',
                'ELEMENTOS': {
                  'inputPlaceHolderPass': 'Você pode alterar o texto da dica para o campo "senha"',
                  'buttons_login_label': 'Você pode alterar o texto do botão de login',
                  'recoveryAccessKey_text': 'Você pode alterar o texto do botão para recuperar a senha',
                }
              },
              'BACKGROUND': {
                'TITULO': 'Imagem de fundo',
                'ELEMENTOS': {
                  'backgroudImage': 'Você pode alterar a imagem de fundo que aparece nesta tela',
                }
              },
            }
          },
          'GENERICOS': {
            'TITULO': 'Elementos genéricos',
            'PASOS': {
              'LOGO': {
                'TITULO': 'Logotipo da corretora',
                'ELEMENTOS': {
                  'logo': 'Você pode fazer upload de uma imagem para alterar o logotipo do corretor'
                }
              },
              'HEADER': {
                'TITULO': 'Elementos de cabeçalho',
                'ELEMENTOS': {
                  'buttons_logout_label': 'Você pode alterar o texto do botão de login',
                  'header_logo': 'Você pode alterar a imagem do logotipo do sistema',
                  'isShowLastLogin_active': 'Você pode escolher mostrar ou ocultar a data do último acesso',
                  'backgroundImage': 'Você pode alterar a imagem de fundo que aparece nesta tela',
                  'header_showUserName': 'Você pode escolher mostrar ou ocultar o nome de usuário'
                }
              },
            }
          },
          'BIENVENIDA': {
            'TITULO': 'Tela de boas vindas',
            'PASOS': {
              'CONTENIDO': {
                'TITULO': 'Conteúdo da tela',
                'ELEMENTOS': {
                  'text': 'Você pode modificar o conteúdo da tela de boas-vindas',
                  'buttons_next_label': 'Você pode alterar o texto do botão para continuar',
                }
              },
              'LOGOUT': {
                'TITULO': 'Mensagem ao sair',
                'ELEMENTOS': {
                  'title': 'Você pode alterar o título da mensagem',
                  'text': 'Você pode alterar o texto da mensagem',
                  'buttons_cancel_label': 'Você pode alterar o texto do botão para cancelar a ação',
                  'buttons_logout_label': 'Você pode alterar o texto do botão para sair',
                }
              },
            }
          },
          'INSTRUCCIONES': {
            'TITULO': 'Tela de instrução',
            'PASOS': {
              'CONTENIDO': {
                'TITULO': 'Conteúdo da tela',
                'ELEMENTOS': {
                  'text': 'Você pode modificar o conteúdo da tela de instrução',
                  'buttons_previous_label': 'Você pode alterar o texto do botão para voltar',
                  'buttons_start_label': 'Você pode alterar o texto do botão para começar',
                  'buttons_continue_label': 'Você pode alterar o texto do botão para continuar',
                }
              },
              'LOGOUT': {
                'TITULO': 'Mensagem ao sair',
                'ELEMENTOS': {
                  'title': 'Você pode alterar o título da mensagem',
                  'text': 'Você pode alterar o texto da mensagem',
                  'buttons_cancel_label': 'Você pode alterar o texto do botão para cancelar a ação',
                  'buttons_logout_label': 'Você pode alterar o texto do botão para sair',
                }
              },
            }
          },
          'TERMINOS': {
            'TITULO': 'Mensagem de aceitação da pesquisa',
            'PASOS': {
              'ACTIVAR': {
                'TITULO': 'Ative a mensagem para aceitar ou rejeitar a pesquisa',
                'ELEMENTOS': {
                  'active': 'Ativar mensagem de pré-partida'
                }
              },
              'CONTENIDO': {
                'TITULO': 'Conteúdo da mensagem',
                'ELEMENTOS': {
                  'header_title': 'Você pode alterar o título da mensagem',
                  'text': 'Você pode alterar o conteúdo da mensagem',
                  'buttons_previous_label': 'Você pode alterar o texto do botão para voltar',
                  'buttons_acept_label': 'Você pode alterar o texto do botão para rejeitar a pesquisa',
                  'buttons_cancel_label': 'Você pode alterar o texto do botão para aceitar a pesquisa'
                }
              },
              'LOGOUT': {
                'TITULO': 'Mensagem ao sair',
                'ELEMENTOS': {
                  'title': 'Você pode alterar o título da mensagem',
                  'text': 'Você pode alterar o texto da mensagem',
                  'buttons_cancel_label': 'Você pode alterar o texto do botão para cancelar a ação',
                  'buttons_logout_label': 'Você pode alterar o texto do botão para sair',
                }
              },
              'NOACEPT': {
                'TITULO': 'Mensagem ao rejeitar a pesquisa',
                'ELEMENTOS': {
                  'title': 'Você pode alterar o título da mensagem',
                  'text': 'Você pode alterar o texto da mensagem',
                  'buttons_saveAndExit_label': 'Você pode alterar o texto do botão para confirmar e sair',
                }
              },
            }
          },
          'SURVEY': {
            'TITULO': 'Tela de pesquisa',
            'PASOS': {
              'NAV': {
                'TITULO': 'Botões de navegação',
                'ELEMENTOS': {
                  'buttons_next_label': 'Você pode alterar o texto do botão para continuar',
                  'buttons_previous_label': 'Você pode alterar o texto do botão para voltar',
                  'buttons_finish_label': 'Você pode alterar o texto do botão para encerrar a pesquisa',
                }
              },
              'INSTRUCCIONES': {
                'TITULO': 'Painel lateral de instrução',
                'ELEMENTOS': {
                  'button_label': 'Você pode alterar o texto do botão para exibir o painel de instruções',
                  'active': 'Você pode escolher mostrar ou ocultar o botão no painel de instruções',
                  'text': 'Você pode modificar o conteúdo da tela de instrução',
                }
              },
              'SOPORTE': {
                'TITULO': 'Painel lateral de dicas de suporte',
                'ELEMENTOS': {
                  'button_label': 'Você pode alterar o texto do botão para exibir o painel de dicas de suporte',
                  'active': 'Você pode escolher mostrar ou ocultar o botão do painel de dicas de suporte',
                  'text': 'Você pode modificar o conteúdo da tela de dicas de suporte',
                }
              },
              'COLUMNA1': {
                'TITULO': 'Declarações: Perspectiva 1',
                'ELEMENTOS': {
                  'title': 'Você pode alterar o título da coluna da perspectiva 1',
                  'tooltip_active': 'Você pode escolher mostrar ou ocultar a dica de ferramenta do título da coluna',
                  'tooltip_text': 'Você pode modificar o conteúdo da dica de ferramenta do título da coluna',
                }
              },
              'COLUMNA2': {
                'TITULO': 'Declarações: Perspectiva 2',
                'ELEMENTOS': {
                  'title': 'Você pode alterar o título da coluna da perspectiva 2',
                  'tooltip_active': 'Você pode escolher mostrar ou ocultar a dica de ferramenta do título da coluna',
                  'tooltip_text': 'Você pode modificar o conteúdo da dica de ferramenta do título da coluna',
                }
              },
              'FINISH_1': {
                'TITULO': 'Mensagem no final da pesquisa',
                'ELEMENTOS': {
                  'title': 'Você pode alterar o título da mensagem',
                  'textAnswered': 'Você pode modificar o texto da mensagem exibida ao responder a todas as perguntas',
                  'textNotAnswered': 'Você pode modificar o texto da mensagem exibida, não respondendo a todas as perguntas',
                  'textFooter': 'Você pode modificar o texto da mensagem',
                  'buttons_previous_label': 'Você pode alterar o texto do botão para voltar',
                  'buttons_close_label': 'Você pode alterar o texto do botão para encerrar a pesquisa',
                }
              },
              'FINISH_2': {
                'TITULO': 'Mensagem após completar a pesquisa',
                'ELEMENTOS': {
                  'windowFinishMessage_title': 'Você pode alterar o título da mensagem',
                  'windowFinishMessage_text': 'Você pode modificar o texto da mensagem',
                  'windowRanking_active': 'Você pode escolher mostrar ou ocultar a mensagem para avaliar a pesquisa',
                  'windowRanking_text': 'Você pode modificar o texto da mensagem para avaliar a pesquisa',
                  'windowFinishMessage_buttons_close_label': 'Você pode alterar o texto do botão para continuar',
                }
              },
              'LOGOUT_1': {
                'TITULO': 'Mensagem ao sair',
                'ELEMENTOS': {
                  'title': 'Você pode alterar o título da mensagem',
                  'text': 'Você pode modificar o texto da mensagem',
                  'textBandRequired': 'Você pode modificar o texto da mensagem de aviso de irreversibilidade',
                  'buttons_previous_label': 'Você pode alterar o texto do botão para cancelar a ação',
                  'buttons_saveAndExit_label': 'Você pode alterar o texto do botão para salvar as alterações e fazer logout',
                }
              },
              'LOGOUT_2': {
                'TITULO': 'Mensagem após o logout',
                'ELEMENTOS': {
                  'title': 'Você pode alterar o título da mensagem',
                  'text': 'Você pode modificar o texto da mensagem',
                  'buttons_close_label': 'Você pode alterar o texto do botão para continuar',
                }
              },
            }
          },
        }
      }
    }
};
